import Vue from 'vue'
import Router from 'vue-router'
import { pathName } from "./pathName"

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import("@/views/home/Home.vue")
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/error-page/404')
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/views/error-page/403')
    },

    {
      path: '/goodsList',
      name: 'goodsList',
      component: () => import("@/views/goodsList/GoodsList.vue")
    },
    {
      path: '/goodDetail',
      name: 'goodDetail',
      component: () => import("@/views/goodDetail/GoodDetail")
    },
    {
      path: '/brandCenter',
      name: 'brandCenter',
      component: () => import("@/views/brandCenter/BrandCenter")
    },
    {
      path: '/brandGoods',
      name: 'brandGoods',
      component: () => import("@/views/brandGoods/BrandGoods")
    },
    {
      path: '/activityZone',
      name: 'activityZone',
      component: () => import("@/views/activityZone/activityZone")
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import("@/views/login/login")
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: () => import("@/views/register/register")
    // },
    // {
    //   path: '/forgetPassword',
    //   name: 'forgetPassword',
    //   component: () => import("@/views/forgetPassword/forgetPassword")
    // },
    {
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: () => import("@/views/shoppingCart/shoppingCart")
    },
    {
      path: '/collect',
      name: 'collect',
      component: () => import("@/views/user/collect")
    },
    {
      path: '/editPassword',
      name: 'editPassword',
      component: () => import("@/views/user/editPassword")
    },
    {
      path: '/addr',
      name: 'addr',
      component: () => import("@/views/user/addr")
    },
    {
      path: '/editUser',
      name: 'editUser',
      component: () => import("@/views/user/editUser")
    },
    {
      path: '/commitOrder',
      name: 'commitOrder',
      component: () => import("@/views/commitOrder/commitOrder")
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import("@/views/pay/pay")
    },
    {
      path: '/offTheStocks',
      name: 'offTheStocks',
      component: () => import("@/views/offTheStocks/index")
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: () => import("@/views/user/myOrder")
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import("@/views/agreement/agreement")
    },
    {
      path: '/billManage',
      name: 'billManage',
      component: () => import("@/views/user/billManage")
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import("@/views/user/orderDetail")
    },
    // {
    //   path: '/billKnow',
    //   name: 'billKnow',
    //   component: () => import("@/views/helpCenter/billKnow")
    // },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: () => import("@/views/helpCenter/contact")
    // },
    // {
    //   path: '/promotion',
    //   name: 'promotion',
    //   component: () => import("@/views/helpCenter/promotion")
    // },
    // {
    //   path: '/shoppingFlow',
    //   name: 'shoppingFlow',
    //   component: () => import("@/views/helpCenter/shoppingFlow")
    // },
    // {
    //   path: '/normalQuestion',
    //   name: 'normalQuestion',
    //   component: () => import("@/views/helpCenter/normalQuestion")
    // },
    // {
    //   path: '/howPay',
    //   name: 'howPay',
    //   component: () => import("@/views/helpCenter/howPay")
    // },
    // {
    //   path: '/servicePolicy',
    //   name: 'servicePolicy',
    //   component: () => import("@/views/helpCenter/servicePolicy")
    // },
    // {
    //   path: '/requestSuggest',
    //   name: 'requestSuggest',
    //   component: () => import("@/views/helpCenter/requestSuggest")
    // },
    // {
    //   path: '/goCompany',
    //   name: 'goCompany',
    //   component: () => import("@/views/helpCenter/requestSuggest")
    // },
    {
      path: '/goCompany',
      name: 'goCompany',
      component: () => import("@/views/helpCenter/index")
    },
    // jjj
    {
      path: '/bussinessInfo',
      name: 'bussinessInfo',
      component: () => import("@/views/user/bussinessInfo/bussinessInfo")
    },
    {
      path: '/addBussinessInfo',
      name: 'addBussinessInfo',
      component: () => import("@/views/user/bussinessInfo/addBussinessInfo")
    },
    {
      path: '/memberInfo',
      name: 'memberInfo',
      component: () => import("@/views/user/bussinessInfo/memberInfo")
    },
    {
      path: '/addrManage',
      name: 'addrManage',
      component: () => import("@/views/user/bussinessInfo/addrManage")
    },
    {
      path: '/billInfo',
      name: 'billInfo',
      component: () => import("@/views/user/bussinessInfo/billInfo")
    },
    {
      path: '/loginAndRegister',
      name: 'loginAndRegister',
      component: () => import("@/views/loginAndRegister/loginAndRegister"),
    },
    {
      path: '/batchOrder',
      name: 'batchOrder',
      component: () => import("@/views/batchOrder/batchOrder"),
    },
    {
      path: '/fastOrder',
      name: 'fastOrder',
      component: () => import("@/views/fastOrder/fastOrder"),
    },
    {
      path: '/intellectQuotedPrice',
      name: 'intellectQuotedPrice',
      component: () => import("@/views/intellectQuotedPrice/intellectQuotedPrice"),
    },
    {
      path: '/individualCode',
      name: 'individualCode',
      component: () => import("@/views/user/individualCode"),
    },
    {
      path: '/individualSuit',
      name: 'individualSuit',
      component: () => import("@/views/user/individualSuit"),
    },
    {
      path: '/enterpriseCode',
      name: 'enterpriseCode',
      component: () => import("@/views/user/enterpriseCode"),
    },
    {
      path: '/enterpriseSuit',
      name: 'enterpriseSuit',
      component: () => import("@/views/user/enterpriseSuit"),
    },
    {
      path: '/authorization',
      name: 'authorization',
      component: () => import("@/views/user/authorization"),
    },
    {
      path: '/xindou',
      name: 'xindou',
      component: () => import("@/views/user/xindou"),
    },
    // {
    //   path: '/advertise',
    //   name: 'advertise',
    //   component: () => import("@/views/helpCenter/advertise")
    // },
    {
      path: '/examine',
      name: 'examine',
      component: () => import("@/views/examine/examine"),
    },
    {
      path: '/invoiceDetail',
      name: 'invoiceDetail',
      component: () => import("@/views/user/invoiceDetail.vue"),
    },
    {
      path: '/logisticsDetail',
      name: 'logisticsDetail',
      component: () => import("@/views/user/logisticsDetail.vue"),
    },
    {
      path: '/orderPay',
      name: 'orderPay',
      component: () => import("@/views/OrderPay/index.vue"),
    },
    {
      path: '/payOk',
      name: 'payOk',
      component: () => import("@/views/OrderPay/payOk.vue"),
    },
  ]
})
// 导航守卫
router.beforeEach((to, from, next) => {

  const { aplus_queue } = window;
  aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [{ is_auto: false }] // 此处上报的数据暂时在后台没有展示
  });

  let { name } = to;
  let title = pathName[name];
  if (title) {
    document.title = title;
  } else {
    let host = document.domain;
    if (host.indexOf('mall81') != -1) {
      document.title = '晋亿实业工业品商城'
    } else if (host.indexOf('mall82') != -1) {
      document.title = '晋顺芯工业品商城'
    } else if (host.indexOf('prod1490') != -1) {
      document.title = '芯崎MRO工业品商城'
    } else {
      document.title = "晋顺芯工业品商城"
    }
  }


  if (to.matched.length === 0) { //匹配前往的路由不存在
    from.name ? next({
      name: from.name
    }) : next('/404');
  } else {
    next();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js